<template>
    <span
        v-if="landPlotStatus"
        class="land-status"
        :class="`land-status--${landPlotStatusMeta.class}`"
    >
        {{ landPlotStatusMeta.text }}
    </span>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { PlotStatus } from '@/types/LandPLot';

    interface Props {
        landPlotStatus: PlotStatus | null;
    }

    const props = withDefaults(defineProps<Props>(), {
        landPlotStatus: null,
    });

    const landPlotStatusMeta = computed(() => {
        switch (props.landPlotStatus) {
            case PlotStatus.free:
                return { text: 'Свободен', class: PlotStatus.free };
            case PlotStatus.booked:
                return { text: 'Забронирован', class: PlotStatus.booked };
            case PlotStatus.occupied:
                return { text: 'Занят', class: PlotStatus.occupied };
            default:
                return { text: '', class: '' };
        }
    });
</script>

<style lang="less">
    .land-status {
        .text-3-mobile();

        background-color: @simple-light;
        border-radius: 100px;
        padding: 4px 11px;

        &--free {
            color: @success;
        }
        &--booked {
            color: @warning;
        }
        &--occupied {
            color: @danger;
        }
    }
</style>
